import { JourneyOccurrencesResponseInterface } from '@interface/journeys';

export const hasOccurence = ({
  createdAt,
  id,
  reason,
}: Omit<
  JourneyOccurrencesResponseInterface,
  'observations' | 'read'
>): boolean => {
  return !!(createdAt && id && reason);
};

export const hasOccurenceViewed = ({
  read,
}: Omit<JourneyOccurrencesResponseInterface, 'observations'>): boolean => {
  return read;
};
